export class DbContext {
    static FailedRequests = 'failedRequests';
    static UnsyncedChanges = 'unsyncedChanges';
    static Bookings = 'bookings';
    static Customers = 'customers';
    static TablesStates = 'tablesStates';
    static Allocations = 'allocations';
    static Providers = 'providers';
    static Todos = 'todos';
    static Templates = 'templates';
    static GridPresets = 'gridPresets';
}
